import { useContext, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';

import { JobsApplyContext, UserContext } from 'contexts';
import { GTM_EVENTS } from 'constants/analytics';
import { fbAnalytics } from 'utils/analytics';
import LoadingOverlay from 'components/LoadingOverlay';
import styles from './SignInPage.module.scss';
import useJobsApply from '../../hooks/useJobsApply';
import Authentication from 'components/Authentication';

const SignInPage = () => {
  const { lastSelectedJob } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useContext(UserContext);

  const signInWithEmail = () => {
    fbAnalytics(GTM_EVENTS.SIGN_UP_EMAIL, { lastSelectedJob });
  };

  return (
    <>
      <section>
        <div className="container container-small">
          <div className={`${styles.SignInContainer} ${styles.signIn} form-holder`} data-qa="signInWindow">
            <form className="small-form">
              <Authentication />
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default SignInPage;
